// extracted by mini-css-extract-plugin
export default {"panel":"ControlPanel_panel__OTves","from_station":"ControlPanel_from_station__aT3qH","to_station":"ControlPanel_to_station__5-2pC"};